import React from 'react';

const Mensaje = () => {
    return (
        <div className='container center' style={{height:"80vh", display:"flex", justifyContent:"center", alignItems:"center", flexDirection:"column"}}>
            <p className='titulo_nv_2' style={{margin:"0"}}>¡Envío exitoso!</p>
            <p>
                Tu formulario ha sido enviado con éxito, <br/>
                nos pondremos en contacto en poco tiempo.
            </p>
            <div className='btn_1' style={{marginTop:"50px"}}>
                <a href="/" style={{color:"#fff"}}>
                    <p>
                        Volver al inicio
                    </p>
                </a>
            </div>
        </div>
    );
};

export default Mensaje;